export async function preloadImages(imageUrls: string[], threshold = 3) {
  const queue: Array<Promise<unknown>> = [];
  const results: any[] = [];
  for (const url of imageUrls) {
    const imagePromise = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ url, status: 'success' });
      };
      img.onerror = () => reject({ url, status: 'error' });
      img.src = url;
    });
    queue.push(imagePromise);
    if (queue.length > threshold) {
      // 等待最早开始的加载任务完成
      const completedPromise: any = await Promise.race(queue);
      results.push(completedPromise);
      // 从队列中移除已完成的 Promise
      queue.splice(queue.indexOf(completedPromise), 1);
    }
  }
  // 等待剩余的图片加载完成
  while (queue.length > 0) {
    const completedPromise: any = await Promise.race(queue);
    results.push(completedPromise);
    queue.splice(queue.indexOf(completedPromise), 1);
  }
  return results;
}
